import React from "react";

export default class SubstanceInfoDosageAxis extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showText: false };
  }

  handleInfoClick = () => {
    alert('Dosage depends on genetics, body mass and other factors. If you decide to use a substance start with an allergy test. You can do more, but you can not do less than already ingested. Data comes from tripsit.me and psychonautwiki.org.');
  };

  parseDosageValue(value) {
    if (!value || typeof value !== 'string') {
      return { min: 0, max: 0, unit: "" }; // Return default if value is null, undefined, or not a string
    }
  
    // Regular expression to capture numeric values and units including '+' if it exists at the end
    const unitMatch = value.match(/[^\d\s-]+(\+)?$/);
    let unit = unitMatch ? unitMatch[0].trim() : "";
  
    // Clip unit to a maximum of 2 characters if it is longer
    if (unit.length > 2 && !unit.includes('+')) {
      unit = unit.substring(0, 2);
    }
  
    // Remove units (and '+' if present) and trim the value
    const numericValue = value.replace(unit, "").trim();
  
    // Handle ranges (e.g., "25 - 75")
    if (numericValue.includes("-")) {
      const [min, max] = numericValue.split("-").map((num) => parseFloat(num.trim()));
      if (!isNaN(min) && !isNaN(max)) {
        const average = (min + max) / 2;
        const roundedAverage = average > 20 ? Math.round(average / 5) * 5 : Math.round(average);
        return { min: roundedAverage, max: roundedAverage, unit };
      }
    }
  
    // Handle single values
    const number = parseFloat(numericValue);
    if (!isNaN(number)) {
      const roundedNumber = number > 20 ? Math.round(number / 5) * 5 : Math.round(number);
      return { min: roundedNumber, max: roundedNumber, unit };
    }
  
    // Default return if parsing fails
    return { min: 0, max: 0, unit: "" };
  }

  render() {
    const { roa, roas } = this.props;
    const { showText } = this.state;

    if (!roa || !roa.dosage || roa.dosage.length === 0) {
      return null;
    }

    const styles = {
      roaContainer: {
        marginTop: "30px",
        marginBottom: "30px",
      },
      dosageAxis: {
        boxShadow:
          "rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -15px, rgba(0, 0, 0, 0.2) 0px -4px 0px inset",
        display: "flex",
        height: "15px",
        margin: "5px 0px 8px 0px",
        borderRadius: "2px",
        overflow: "hidden",
        backgroundImage: `linear-gradient(to right, 
          #00FF00 0%, 
          #FFFF00 25%, 
          #FFA500 50%, 
          #FF0000 75%
        )`,
        width: "100%",
        cursor: "pointer", // Makes dosage axis clickable
      },
      dosageValueLabel: {
        flex: 1,
        textAlign: "center",
        color: "#333",
        fontSize: "0.8em",
      },
      axisLabelContainer: {
        display: "flex",
        justifyContent: "space-between",
      },
      axisLabel: {
        flex: 1,
        textAlign: "center",
        color: "#333",
        fontSize: "0.8em",
      },
      bioavailabilityContainer: {
        maxHeight: showText ? "200px" : "0",
        overflow: "hidden",
        transition: "max-height 0.5s ease-in-out",
      },
      bioavailability: {
        marginTop: "10px",
        fontSize: "0.9em",
        color: "#555",
      },
      relativeBioavailabilityRow: {
        marginTop: "10px",
        fontSize: "0.9em",
        color: "#555",
      },
    };

    return (
      <div style={styles.roaContainer}>
        {/* Nagłówek z ikoną */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline', marginBottom: '30px' }}>
          <h2 style={{ margin: 0 }}>Dosage</h2>
          <i 
          className="zmdi zmdi-info-outline" 
          style={{ marginLeft: '10px', cursor: 'pointer', padding: '10px' }} 
          onClick={this.handleInfoClick}
        ></i>
        </div>

        {/* Dosage Axis */}
        <div style={styles.axisLabelContainer}>
          {roa.dosage.map((dosage, index) => {
            const { min, unit } = this.parseDosageValue(dosage.value);
            return dosage.value ? (
              <span key={index} style={styles.dosageValueLabel}>
                {min} {unit}
              </span>
            ) : null;
          })}
        </div>
        <div style={styles.dosageAxis}></div>
        <div style={styles.axisLabelContainer}>
          {roa.dosage.map((dosage, index) => (
            <span key={index} style={styles.axisLabel}>
              {dosage.name}
            </span>
          ))}
        </div>
      </div>
    );
  }
}
